// extracted by mini-css-extract-plugin
export var boxItems = "_bc-1";
export var boxItemsLg = "_bc-2";
export var button = "_bc-7";
export var buttonHoverless = "_bc-9";
export var buttonLg = "_bc-8";
export var filterGroupBox = "_bc-0";
export var icon = "_bc-3";
export var iconSecondary = "_bc-6";
export var iconWrapper = "_bc-4";
export var iconWrapperLg = "_bc-5";
export var truncatedLabel = "_bc-a";